var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 120,
    viewBox: "0 0 127 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.02 96.58L27.38 115.31L34.19 75.64L5.36 47.54L45.2 41.75L63.02 5.65L80.83 41.75L120.67 47.54L91.84 75.64L98.65 115.31L63.02 96.58Z",
    fill: "#FCD25E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.02 11.3L79.18 44.03L115.31 49.28L89.17 74.76L95.34 110.74L63.03 93.75L30.72 110.74L36.89 74.76L10.73 49.28L46.86 44.03L63.02 11.3ZM63.02 0L43.55 39.46L0 45.79L31.51 76.51L24.07 119.89L63.02 99.42L101.97 119.89L94.53 76.51L126.04 45.79L82.49 39.46L63.02 0Z",
    fill: "#491C0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.01 11.3L51.59 44.03L50.1 48.32L15.62 50.38L36.88 74.76L10.73 49.28L46.86 44.03L63.01 11.3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.15 74.77L95.32 110.74L63.01 93.76L90.35 104.1L83.41 68.84L115.3 49.28L89.15 74.77Z",
    fill: "#B27D2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.17 44.03L112.02 51.29L115.3 49.28L79.17 44.03Z",
    fill: "#EAD381"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.02 51.29L74.36 66.7L75.92 82.47L63.02 79.68L47.55 84.94L36.95 74.77L15.69 50.38L50.17 48.32L51.66 44.03L63.09 11.29L79.25 44.03L112.02 51.29Z",
    fill: "#FFDC85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreator);
export default __webpack_public_path__ + "static/media/creator.141073fa87ba9fef53044cd9bfeb4a3c.svg";
export { ForwardRef as ReactComponent };